import { useMemo } from "react";
import { useSelector } from "react-redux";
import { EMPTY_CALENDAR_CONFIG } from "helpers/calendar/calendarFallback2026";
import {
  buildAutoDraftDateSet,
  buildClosureLookup,
  buildClosedDateSet,
} from "helpers/calendar/calendarTerms";

export default function useCalendarConfig() {
  const calendar = useSelector((state) => state.contentfulReducer.calendar);

  const config = useMemo(
    () => calendar?.config || { ...EMPTY_CALENDAR_CONFIG, terms: [] },
    [calendar?.config]
  );

  const autoDraftDates = useMemo(
    () => buildAutoDraftDateSet(config),
    [config]
  );

  const closureLookup = useMemo(() => buildClosureLookup(config), [config]);

  const closedDates = useMemo(
    () => buildClosedDateSet(config),
    [config]
  );

  const pdfUrl = calendar?.url || null;
  const navLabel = calendar?.label || "Calendar";
  const title =
    config.title ||
    (config.year ? `ACE Calendar ${config.year}` : "Season Calendar");
  const hasTerms = config.terms.length > 0;
  const hasClosures = (config.closures || []).length > 0;
  const isReady = Boolean(calendar?.config && hasTerms);

  return {
    config,
    autoDraftDates,
    closedDates,
    closureLabels: closureLookup.labels,
    pdfUrl,
    navLabel,
    title,
    year: config.year,
    intro: config.intro,
    subtitle: config.subtitle,
    hasTerms,
    hasClosures,
    isReady,
  };
}
